/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { HamburgerIcon } from '../../components/icons';
import { HeaderData } from '../../models/cms';
import Sidemenu from './Sidemenu';
import UserHeaderNotifications from './Notifications';
import logoImage from '../../assets/images/ecodrive_logo.svg';

interface CustomState {
  active?: boolean;
  data: HeaderData;
  loggedIn: boolean;
}

const HeaderCanvas = ({ data, active, loggedIn }: CustomState) => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }

    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, [menuOpen]);

  return (
    <header
      className={`w-full px-5 lg:px-7 xl:px-[50px] grid grid-cols-1 lg:gap-4 items-center py-5 leading-[1.2] hover:bg-white duration-1000 ${
        active ? 'absolute top-0 left-0 z-10' : 'bg-white'
      } ${loggedIn ? 'loggedIn' : ''}`}
    >
      <Link to="/" className="relative z-[2]">
        <img
          src={data?.logo?.url ?? logoImage}
          alt="Ecodrive"
          width={193}
          height={49}
        />
      </Link>
      <div className="flex relative justify-between items-center w-full lg:order-last z-[2]">
        {loggedIn && (
          <div className="relative">
            <UserHeaderNotifications notifyId="webNotify" />
          </div>
        )}
        <span
          className="lg:hidden ltr:ml-7 rtl:mr-7"
          onClick={() => {
            setMenuOpen(!menuOpen);
          }}
          role="button"
          tabIndex={0}
        >
          <HamburgerIcon />
        </span>
      </div>
      <Sidemenu
        data={data}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        loggedIn={loggedIn}
      />
    </header>
  );
};

export default HeaderCanvas;
